<template>
  <section class="section first_page">
    <div class="container-flud ">
      <loading-block v-if="is_load==false" :loading="!is_load"/>
      <div class="col-md-12 center-block loading_div " v-if="is_load==false">
        <h2>Идет загрузка...</h2>
      </div>
      <div     v-if="is_load">
        <common-user-page :user="user" />





      </div>
    </div>
  </section>
</template>

<script>
import Api from "@/models/Api";
import LoadingBlock from "@/components/Custom/LoadingBlock";
import Vue from "vue";
import CommonUserPage from "@/components/user_page/CommonUserPage";

export default {
  name: "MainUserPage",
  data(){
    return {
      "is_load":false,
      'user':null,
      'image_url':null,
    };
  },
  components: {LoadingBlock,CommonUserPage},
  mounted: function () {
    var app=this;
    var id=this.$route.params.user_id;
    app.is_load=false;
    app.image_url = Vue.config.IMAGE_URL;
    app.loadMainData(id);
  },
  methods:{
    loadMainData(id){
      var app=this;
      Api.loadUserPageMain(id,function(data){
        app.user=data.user;
        app.is_load=true;
      },function(error){

        if(error.response.data.code==404){
          app.$router.push({name:'404'});
        }
      });
    }
  }
}
</script>

<style scoped>

</style>